import React from 'react';

const C = {
  trasporto: '#EB1C24',
  alloggio:  '#0071BA',
  attivita:  '#FF5B00',
  servizi:   '#009045',
  dark:      '#0a1628',
  white:     '#ffffff',
  text:      '#1a1a2e',
  textLight: '#6b7280',
  border:    '#e0e4ea',
};

const MOBILE_CSS = `
  .pktb-row { display: grid; grid-template-columns: 1fr 1fr; }
  @media (max-width: 600px) {
    .pktb-row { grid-template-columns: 1fr !important; }
    .pktb-logo { display: none !important; }
    .pktb-cell-tl { border-right: none !important; }
    .pktb-cell-bl { border-right: none !important; border-bottom: 2px solid #e0e4ea !important; }
    .pktb-header { padding: 10px 10px !important; gap: 6px !important; }
    .pktb-header-title { font-size: 20px !important; }
    .pktb-header-price { font-size: 15px !important; }
    .pktb-header-meta { font-size: 12px !important; }
    .pktb-header-sub { font-size: 10px !important; }
    .pktb-cell { padding: 7px 8px !important; }
    .pktb-seglabel { margin-bottom: 8px !important; }
    .pktb-seglabel-icon { height: 14px !important; }
    .pktb-seglabel-text { font-size: 11px !important; }
    .pktb-volo-badge-row { margin-bottom: 3px !important; }
    .pktb-volo-time { font-size: 13px !important; }
    .pktb-volo-city { font-size: 10px !important; }
    .pktb-volo-mid { font-size: 10px !important; }
    .pktb-volo-price { font-size: 13px !important; }
    .pktb-volo-gap { height: 5px !important; }
    .pktb-alloggio-head { margin-bottom: 5px !important; }
    .pktb-alloggio-title { font-size: 13px !important; }
    .pktb-alloggio-meta { font-size: 11px !important; }
    .pktb-alloggio-price { font-size: 13px !important; }
    .pktb-features { gap: 3px 8px !important; margin-top: 5px !important; padding-top: 5px !important; }
    .pktb-feature-text { font-size: 11px !important; }
    .pktb-list-row { padding: 3px 0 !important; }
    .pktb-list-text { font-size: 12px !important; }
    .pktb-list-price { font-size: 13px !important; }
    .pktb-footer { padding: 7px 12px !important; }
    .pktb-footer-pct { font-size: 15px !important; }
    .pktb-footer-text { font-size: 12px !important; }
  }
`;

export default function PacchettoCardBarcelona() {
  return (
    <div style={{ backgroundColor: C.white, borderRadius: '16px', overflow: 'hidden', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', fontFamily: 'Roboto, sans-serif', textAlign: 'left' }}>
      <style>{MOBILE_CSS}</style>

      {/* HEADER */}
      <div className="pktb-header" style={{ backgroundColor: C.dark, padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <span className="pktb-header-title" style={{ fontSize: '34px', fontWeight: 900, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase', lineHeight: 1 }}>BARCELLONA</span>
        <span className="pktb-header-meta" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>4 notti &nbsp;·&nbsp; 2 adulti</span>
        <div style={{ textAlign: 'right' }}>
          <div className="pktb-header-price" style={{ fontSize: '26px', fontWeight: 900, color: C.white, lineHeight: 1 }}>€ 600,00 <span style={{ fontSize: '13px', fontWeight: 400 }}>/ cad.</span></div>
          <div className="pktb-header-sub" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', marginTop: '3px' }}>spesa indicativa</div>
        </div>
      </div>

      {/* 2x2 GRID */}
      <div>

        {/* RIGA 1: Trasporto + Alloggio */}
        <div className="pktb-row" style={{ position: 'relative' }}>

          <div className="pktb-logo" style={{
            position: 'absolute', bottom: '-25px', left: '50%',
            transform: 'translateX(-50%)', zIndex: 10,
            backgroundColor: C.white, borderRadius: '50%',
            width: '50px', height: '50px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.13)',
            border: `2px solid ${C.border}`,
          }}>
            <img src="/images/logo_mondo.svg" alt="OCTA" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
          </div>

          {/* TRASPORTO */}
          <div className="pktb-cell pktb-cell-tl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}`, borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.trasporto} img="/images/trasporto_icona.png" label="TRASPORTO" />
            <VologRow direz="Andata" oraPart="07.15" cittaPart="VERONA" durata="2h 05m" tipo="diretto" oraArr="09.20" cittaArr="BARCELLONA" prezzo="€ 185,00" colore={C.trasporto} />
            <div className="pktb-volo-gap" style={{ height: '10px' }} />
            <VologRow direz="Ritorno" oraPart="21.00" cittaPart="BARCELLONA" durata="2h 05m" tipo="diretto" oraArr="23.05" cittaArr="VERONA" prezzo="€ 185,00" colore={C.trasporto} />
          </div>

          {/* ALLOGGIO */}
          <div className="pktb-cell" style={{ padding: '14px 16px', borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.alloggio} img="/images/alloggio_icona.png" label="ALLOGGIO" />
            <div className="pktb-alloggio-head" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px', marginBottom: '8px' }}>
              <div>
                <div className="pktb-alloggio-title" style={{ fontSize: '17px', fontWeight: 900, fontStyle: 'italic', color: C.text }}>HOTEL CATALONIA EIXAMPLE<span style={{ color: '#f59e0b' }}>★★★★</span></div>
                <div className="pktb-alloggio-meta" style={{ fontSize: '13px', color: C.text, marginTop: '3px' }}>camera doppia superior · 28 m²</div>
                <div className="pktb-alloggio-meta" style={{ fontSize: '13px', color: C.text }}>balcone · minibar · aria cond.</div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div className="pktb-alloggio-price" style={{ fontSize: '17px', fontWeight: 900, color: C.text }}>€ 320,00</div>
                <div style={{ marginTop: '4px', display: 'inline-flex', alignItems: 'center', gap: '4px', backgroundColor: '#e8f5e9', borderRadius: '5px', padding: '3px 6px' }}>
                  <span style={{ fontSize: '11px', fontWeight: 700, color: C.servizi, textTransform: 'uppercase' }}>OTTIMA</span>
                  <span style={{ fontSize: '13px', fontWeight: 900, color: C.white, backgroundColor: C.alloggio, borderRadius: '3px', padding: '1px 5px' }}>8.3</span>
                </div>
              </div>
            </div>
            <div className="pktb-features" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px', marginTop: '8px', borderTop: `1px solid ${C.border}`, paddingTop: '8px' }}>
              {['Wi-Fi gratuito in camera','Colazione inclusa','Smart TV + Netflix','Servizio in camera','Piscina sul tetto','Concierge 24h'].map((s, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: C.alloggio, flexShrink: 0 }} />
                  <span className="pktb-feature-text" style={{ fontSize: '13px', color: C.text }}>{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGA 2: Servizi + Attività */}
        <div className="pktb-row">

          {/* SERVIZI */}
          <div className="pktb-cell pktb-cell-bl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}` }}>
            <SegLabel colore={C.servizi} img="/images/servizi_icona.png" label="SERVIZI" />
            {[
              { nome: 'Collegamento aeroportuale A/R', prezzo: '€ 44,00' },
              { nome: 'Transport Card T-Casual 4 giorni', prezzo: '€ 56,00' },
            ].map((item, i) => (
              <div key={i} className="pktb-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < 1 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.servizi, flexShrink: 0 }} />
                <span className="pktb-list-text" style={{ flex: 1, fontSize: '16px', color: C.text }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.servizi, border: `1px solid ${C.servizi}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap' }}>dettagli</span>
                <span className="pktb-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right' }}>{item.prezzo}</span>
              </div>
            ))}
          </div>

          {/* ATTIVITÀ */}
          <div className="pktb-cell" style={{ padding: '14px 16px' }}>
            <SegLabel colore={C.attivita} img="/images/attivita_icona.png" label="ATTIVITÀ" />
            {[
              { nome: 'Spettacolo di flamenco "Tablao Cordobes"', prezzo: '€ 130,00' },
              { nome: 'Sagrada Família con skip-the-line', prezzo: '€ 70,00' },
              { nome: 'Park Güell — zona monumentale', prezzo: '€ 40,00' },
              { nome: 'Museu Picasso de Barcelona', prezzo: '€ 48,00' },
              { nome: 'Tour Barri Gòtic + La Boqueria', prezzo: '€ 60,00' },
              { nome: 'Camp Nou Experience — museo FC Barcellona', prezzo: '€ 62,00' },
            ].map((item, i, arr) => (
              <div key={i} className="pktb-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < arr.length - 1 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.attivita, flexShrink: 0 }} />
                <span className="pktb-list-text" style={{ flex: 1, fontSize: '16px', color: C.text, lineHeight: 1.3 }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.attivita, border: `1px solid ${C.attivita}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>dettagli</span>
                <span className="pktb-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right', flexShrink: 0 }}>{item.prezzo}</span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* 79% MATCH */}
      <div className="pktb-footer" style={{ padding: '10px 24px', backgroundColor: C.dark, display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span className="pktb-footer-pct" style={{ fontSize: '20px', fontWeight: 900, color: C.white, textDecoration: 'underline', textDecorationColor: C.trasporto, textDecorationThickness: '3px' }}>79%</span>
        <span className="pktb-footer-text" style={{ fontSize: '16px', color: C.white, fontWeight: 400 }}>In linea con il tuo profilo e le tue aspettative</span>
      </div>

    </div>
  );
}

function SegLabel({ colore, img, label }) {
  return (
    <div className="pktb-seglabel" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px', marginBottom: '12px' }}>
      <img src={img} alt={label} className="pktb-seglabel-icon" style={{ height: '18px', objectFit: 'contain' }} />
      <span className="pktb-seglabel-text" style={{ fontSize: '13px', fontWeight: 900, color: colore, textTransform: 'uppercase', letterSpacing: '0.12em' }}>{label}</span>
    </div>
  );
}

function VologRow({ direz, oraPart, cittaPart, durata, tipo, oraArr, cittaArr, prezzo, colore }) {
  return (
    <div>
      <div className="pktb-volo-badge-row" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
        <span style={{ backgroundColor: colore, color: '#fff', fontSize: '11px', fontWeight: 800, padding: '2px 7px', borderRadius: '3px', letterSpacing: '0.04em' }}>{direz}</span>
        <span style={{ color: colore, fontSize: '13px' }}>✈</span>
        <span style={{ marginLeft: 'auto', fontSize: '11px', color: colore, border: `1px solid ${colore}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600 }}>dettagli</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <div style={{ textAlign: 'left' }}>
          <div className="pktb-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraPart}</div>
          <div className="pktb-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaPart}</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center', minWidth: '60px' }}>
          <div className="pktb-volo-mid" style={{ fontSize: '13px', fontWeight: 700, color: C.text }}>{durata}</div>
          <div style={{ height: '1px', backgroundColor: C.border, margin: '2px 0', position: 'relative' }}>
            <span style={{ position: 'absolute', right: 0, top: '-5px', color: C.text, fontSize: '11px' }}>▶</span>
          </div>
          <div className="pktb-volo-mid" style={{ fontSize: '13px', color: C.text }}>{tipo}</div>
        </div>
        <div style={{ textAlign: 'left' }}>
          <div className="pktb-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraArr}</div>
          <div className="pktb-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaArr}</div>
        </div>
        <div className="pktb-volo-price" style={{ fontWeight: 900, fontSize: '17px', color: C.text, marginLeft: 'auto' }}>{prezzo}</div>
      </div>
    </div>
  );
}
